<template>
  <div class="article-detail-page">
    <header class="page-header">
      <div class="container">
        <nav class="breadcrumb">
          <a href="/">首页</a>
          <span v-for="(crumb, index) in breadcrumbList" :key="crumb.id">
            > <a href="#" @click.prevent="goToCategory(crumb.id)">{{ crumb.name }}</a>
          </span>
          <span>></span>
          <a href="#" @click.prevent="goBack" class="back-link">返回上页</a>
        </nav>
      </div>
    </header>

    <div class="container">
      <div class="main-layout">
        <aside class="sidebar">
          <div class="sidebar-section">
            <h3>最新文章</h3>
            <ul class="hot-list">
              <template v-for="(item, index) in relatedArticles">
                <li v-if="getExternalLink(item)" :key="'side-'+index" class="hot-list-item">
                  <a :href="getExternalLink(item)" target="_blank">
                    <span class="hot-rank">{{ index + 1 }}</span>
                    <div class="article-info">
                      <span class="hot-title">{{ item.title || item.post_title }}</span>
                      <div class="hot-meta">
                        <span class="hot-date">{{ item.date || '' }}</span>
                        <span v-if="getCategoryName(item)" class="hot-category-tag" @click.stop.prevent="goToCategoryByItem(item)">
                          {{ getCategoryName(item) }}
                        </span>
                      </div>
                    </div>
                    <svg class="external-link-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
                      <polyline points="15 3 21 3 21 9"></polyline>
                      <line x1="10" y1="14" x2="21" y2="3"></line>
                    </svg>
                  </a>
                </li>
                <li v-else :key="'side2-'+index" class="hot-list-item">
                  <div @click="goToDetail(item)">
                    <span class="hot-rank">{{ index + 1 }}</span>
                    <div class="article-info">
                      <span class="hot-title">{{ item.title || item.post_title }}</span>
                      <div class="hot-meta">
                        <span class="hot-date">{{ item.date || '' }}</span>
                        <span v-if="getCategoryName(item)" class="hot-category-tag" @click.stop.prevent="goToCategoryByItem(item)">
                          {{ getCategoryName(item) }}
                        </span>
                      </div>
                    </div>
                  </div>
                </li>
              </template>
            </ul>
          </div>
        </aside>

        <div class="main-content-col">
          <article class="article-content">
            <h1 class="article-title">{{ article.title }}</h1>
            <div class="article-meta">
              <span class="meta-item">发布时间: {{ article.date }}</span>
            </div>
            <div class="article-body" v-html="renderContent(article.content)">
            </div>
          </article>
          <div class="article-nav">
            <div class="prev-article" v-if="prevArticle">
              <span class="nav-label">上一篇</span>
              <a href="#" @click.prevent="goToDetail(prevArticle)">{{ prevArticle.title || prevArticle.post_title }}</a>
            </div>
            <div class="next-article" v-if="nextArticle">
              <span class="nav-label">下一篇</span>
              <a href="#" @click.prevent="goToDetail(nextArticle)">{{ nextArticle.title || nextArticle.post_title }}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'ArticleDetail',
  data() {
    return {
      article: {
        id: '',
        title: '',
        content: '',
        date: '',
        author: '',
        category: null
      },
      flatCategories: [],
      relatedArticles: [],
      prevArticle: null,
      nextArticle: null
    }
  },
  computed: {
    breadcrumbList() {
      const path = []
      if (!this.article.category) return path
      
      const catMap = {}
      this.flatCategories.forEach(c => {
        catMap[c.id] = c
      })
      
      let currentCat = null
      if (typeof this.article.category === 'object' && this.article.category) {
        currentCat = this.article.category
      } else {
        const catId = this.article.category
        currentCat = catMap[catId]
      }
      
      if (currentCat && currentCat.id && currentCat.id !== 0) {
        let tempId = currentCat.id
        const visited = new Set()
        
        while (tempId && tempId !== 0 && !visited.has(tempId)) {
          visited.add(tempId)
          const cat = catMap[tempId]
          if (cat) {
            path.unshift({ id: cat.id, name: cat.name })
            tempId = cat.parent
          } else {
            break
          }
        }
        
        if (path.length === 0 && currentCat.name) {
          path.push({ id: currentCat.id, name: currentCat.name })
        }
      }
      
      return path
    }
  },
  watch: {
    '$route.params.id'(newId, oldId) {
      console.log('=== 路由参数id变化了 ===', oldId, '→', newId)
      if (newId && newId !== oldId) {
        window.scrollTo(0, 0);
        (async () => {
          await this.fetchArticle(newId)
          await this.fetchRelatedArticles()
        })();
      }
    }
  },
  async mounted() {
    window.scrollTo(0, 0);
    this.fetchFlatCategories()
    const articleId = this.$route.params.id
    await this.fetchArticle(articleId)
    await this.fetchRelatedArticles()
  },
  methods: {
    getExternalLink(item) {
      if (!item || typeof item !== 'object') return ''
      return item.外链 || item.external_link || ''
    },
    getCategoryName(item) {
      if (!item || typeof item !== 'object') return ''
      if (typeof item.category === 'object' && item.category && item.category.name) {
        return item.category.name
      }
      if (typeof item.category === 'string' && item.category.trim()) {
        return item.category
      }
      return ''
    },
    async fetchFlatCategories() {
      try {
        const response = await axios.get('/api/categories')
        this.flatCategories = response.data.flat || []
      } catch (error) {
        console.error('获取分类失败:', error)
      }
    },
    async fetchArticle(id) {
      try {
        const response = await axios.get(`/api/post/${id}`)
        console.log('=== 文章详情API完整响应 ===', response.data)
        const data = response.data.data || response.data
        this.article = data
        this.prevArticle = data.prev_article || data.prev || null
        this.nextArticle = data.next_article || data.next || null
        console.log('=== this.article 赋值后 ===', this.article)
        console.log('=== prevArticle 从API拿到 ===', this.prevArticle)
        console.log('=== nextArticle 从API拿到 ===', this.nextArticle)
      } catch (error) {
        console.error('获取文章详情失败:', error)
      }
    },
    async fetchRelatedArticles() {
      try {
        console.log('=== fetchRelatedArticles 开始（获取全站最新10篇文章，排除基层天地）===')
        const responseAll = await axios.get('/api/latest-posts')
        this.relatedArticles = (responseAll.data.data || []).slice(0, 10)
      } catch (error) {
        console.error('获取相关文章失败:', error)
      }
    },
    renderContent(content) {
      if (!content) return ''
      let html = content
        .replace(/### (.*)/g, '<h3>$1</h3>')
        .replace(/## (.*)/g, '<h2>$1</h2>')
        .replace(/# (.*)/g, '<h1>$1</h1>')
        .replace(/\*\*(.*)\*\*/g, '<strong>$1</strong>')
        .replace(/\*(.*)\*/g, '<em>$1</em>')
        .replace(/__(.*)__/g, '<u>$1</u>')
        .replace(/~~(.*)~~/g, '<del>$1</del>')
        .replace(/`([^`]+)`/g, '<code>$1</code>')
        .replace(/```(\w+)?\n([\s\S]*?)```/g, '<pre><code>$2</code></pre>')
        .replace(/^> (.*)$/gm, '<blockquote>$1</blockquote>')
        .replace(/^- (.*)$/gm, '<li>$1</li>')
        .replace(/^\d+\. (.*)$/gm, '<li>$1</li>')
        .replace(/\n/g, '<br>')
      
      html = html.replace(/<li>/g, '<ul><li>').replace(/<\/li>(?!<li>)/g, '</li></ul>')
      
      return html
    },
    async goToDetail(article) {
      console.log('=== goToDetail 被点击 ===', article)
      const link = this.getExternalLink(article)
      const id = typeof article === 'object' ? (article.id || article.ID) : article
      if (typeof article === 'object' && link) {
        console.log('打开外链:', link)
        try {
          const response = await axios.get(`/api/hit/${id}`)
          console.log('外链浏览记录写入成功:', response.data)
          const finalLink = response.data.external_link || link
          window.open(finalLink, '_blank')
        } catch (err) {
          console.error('记录外链浏览失败，直接跳转:', err)
          window.open(link, '_blank')
        }
      } else {
        const targetPath = `/article/${id}`
        console.log('跳转到文章详情，目标路径:', targetPath)
        console.log('当前路由路径:', this.$route.path)
        window.scrollTo(0, 0)
        
        if (this.$route.path === targetPath) {
          console.log('已经在当前页面，重新刷新加载文章数据')
          await this.fetchArticle(id)
          await this.fetchRelatedArticles()
          return
        }
        
        try {
          await this.$router.push(targetPath)
          console.log('路由跳转成功，手动加载新文章数据')
          await this.fetchArticle(id)
          await this.fetchRelatedArticles()
        } catch (err) {
          console.log('导航错误已忽略:', err)
          await this.fetchArticle(id)
          await this.fetchRelatedArticles()
        }
      }
    },
    goToCategory(categoryId) {
      this.$router.push(`/articles?category=${categoryId}`)
    },
    goBack() {
      this.$router.go(-1)
    },
    goToCategoryByItem(item) {
      let categoryId
      if (typeof item.category === 'object' && item.category && item.category.id) {
        categoryId = item.category.id
      } else {
        categoryId = item.category
      }
      if (categoryId) {
        this.$router.push(`/articles?category=${categoryId}`)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.article-detail-page {
  min-height: 100vh;
  background: #f5f5f5;
}

.page-header {
  position: sticky;
  top: 198px;
  z-index: 150;
  background: white;
  border-bottom: 1px solid #eee;
  padding: 15px 0;

  .breadcrumb {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #666;

    a {
      color: #4ecdc4;
      text-decoration: none;

      &:hover {
        text-decoration: underline;
      }

      &.back-link {
        color: #333;
        font-weight: bold;
      }
    }

    span {
      margin: 0 8px;
      color: #999;
    }
  }
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0px 20px;
}

.main-layout {
  display: flex;
  gap: 30px;
  margin-top: 16px;
}

.sidebar {
  width: 300px;
  flex-shrink: 0;
}

.sidebar-section {
  background: white;
  border-radius: 10px;
  padding: 20px;
  margin-bottom: 20px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);

  h3 {
    font-size: 16px;
    font-weight: bold;
    color: #333;
    margin-bottom: 15px;
    padding-bottom: 10px;
    border-bottom: 2px solid #4ecdc4;
  }
}

.hot-list {
  list-style: none;
  padding: 0;
  margin: 0;

  li {
    display: flex;
    align-items: flex-start;
    padding: 10px 0;
    border-bottom: 1px dashed #eee;

    a, div {
      display: flex;
      align-items: flex-start;
      flex: 1;
      text-decoration: none;
      color: inherit;
      cursor: pointer;
    }

    &.hot-list-item:not(:has(a)) {
      cursor: pointer;
    }

    &:last-child {
      border-bottom: none;
    }

    .article-info {
      flex: 1;
      min-width: 0;
      display: flex;
      flex-direction: column;
    }

    .hot-rank {
      width: 24px;
      height: 24px;
      background: #4ecdc4;
      color: white;
      text-align: center;
      line-height: 24px;
      font-size: 12px;
      border-radius: 50%;
      margin-right: 10px;
      flex-shrink: 0;
      font-family: 'Microsoft YaHei', 'PingFang SC', sans-serif;
    }

    .hot-rank::before {
      display: none !important;
      content: none !important;
    }

    .hot-title {
      flex: 1;
      font-size: 14px;
      color: #333;
      line-height: 1.6;
      word-break: break-all;
    }

    .hot-meta {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 4px;
      width: 100%;
    }

    .hot-date {
      font-size: 12px;
      color: #999;
    }
    
    .external-link-icon {
      margin-left: 8px;
      color: #999;
      flex-shrink: 0;
      margin-top: 2px;
    }
    
    .hot-category-tag {
      font-size: 11px;
      background: #4ecdc4;
      color: white;
      padding: 3px 10px;
      border-radius: 3px;
      cursor: pointer;
      transition: opacity 0.3s;
      
      &:hover {
        opacity: 0.85;
      }
    }
  }
}

.article-content {
  flex: 1;
  background: white;
  border-radius: 10px;
  padding: 30px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);

  .article-title {
    font-size: 28px;
    font-weight: bold;
    color: #333;
    margin-bottom: 20px;
    line-height: 1.4;
  }

  .article-meta {
    display: flex;
    gap: 20px;
    margin-bottom: 30px;
    padding-bottom: 20px;
    border-bottom: 1px solid #eee;

    .meta-item {
      font-size: 14px;
      color: #666;
    }
  }

  .article-body {
    line-height: 1.8;
    color: #333;
    font-size: 16px;

    h1, h2, h3 {
      margin: 20px 0 15px;
      color: #333;
    }

    h1 { font-size: 24px; }
    h2 { font-size: 20px; }
    h3 { font-size: 18px; }

    p {
      margin-bottom: 15px;
    }

    strong { font-weight: bold; }
    em { font-style: italic; }
    u { text-decoration: underline; }
    del { text-decoration: line-through; }

    code {
      background: #f5f5f5;
      padding: 2px 6px;
      border-radius: 3px;
      font-family: monospace;
    }

    pre {
      background: #333;
      color: white;
      padding: 15px;
      border-radius: 5px;
      overflow-x: auto;
      margin: 15px 0;

      code {
        background: none;
        padding: 0;
        color: inherit;
      }
    }

    blockquote {
      border-left: 4px solid #4ecdc4;
      padding-left: 15px;
      color: #666;
      margin: 15px 0;
      font-style: italic;
    }

    ul, ol {
      margin: 15px 0;
      padding-left: 30px;

      li {
        margin-bottom: 8px;
      }
    }
  }
}

.main-content-col {
  flex: 1;
  display: flex;
  flex-direction: column;
  margin-left: 20px;
}

.article-nav {
  background: white;
  border-radius: 10px;
  padding: 30px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: space-between;
  margin-top: 20px;

  .nav-label {
    display: block;
    font-size: 12px;
    color: #999;
    margin-bottom: 5px;
  }

  a {
    font-size: 14px;
    color: #4ecdc4;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }

  .prev-article, .next-article {
    flex: 1;
  }

  .next-article {
    text-align: right;
  }
}
</style>
